module.exports = __webpack_public_path__ + "img/mask.io.3.c395ac22.png";